import * as React from 'react'
import { Helmet } from 'react-helmet'
import { withRouter } from 'react-router'

// components
import CardSlider from '../../../../components/home/CardSlider/CardSlider'
import MerchantsListModal from '../../../../components/home/MerchantsListModal/MerchantsListModal'
import StoreModal from '../../../../components/home/StoreModal/StoreModal'
import CardListModal from '../../../../components/ui/CardListModal/CardListModal'
import ArticleCard from '../../../../components/ui/ArticleCard/ArticleCard'
import DashboardLayout from '../../../../components/ui/DashboardLayout/DashboardLayout'
import Section from '../../../../components/ui/Section/Section'
import Icon from '../../../../components/ui/Icon/Icon'
import ContactUsModal from '../../../../components/home/ContactUsModal/ContactUsModal'
import OurMallsModal from '../../../../components/home/OurMallsModal/OurMallsModal'
import FeaturedCard from '../../../../components/home/FeaturedCard/FeaturedCard'
import EventsCard from '../../../../components/home/EventsCard/EventsCard'
import PromoCard from '../../../../components/home/PromoCard/PromoCard'
import ShopDineCard from '../../../../components/home/ShopDineCard/ShopDineCard'
import TncModal from '../../../../components/home/TncModal2/TncModal'
import PrivacyNoticeModal from '../../../../components/home/PrivacyPolicyModal2/PrivacyPolicyModal'
import MarketingContentModal from '../../../../components/home/MarketingContentModal/MarketingContentModal'
import SliderLoader from '../../../../components/home/SliderLoader/SliderLoader'
import { BannerCaption, ButtonNavWrapper, ButtonNav } from './MainView.style'

// ads
import DesktopLeaderboard from '../../../../components/ads/DesktopLeaderboard/DesktopLeaderboard'
import MobileRectangle from '../../../../components/ads/MobileRectangle/MobileRectangle'
import ResponsiveAdsContainer from '../../../../components/ads/ResponsiveAdsContainer/ResponsiveAdsContainer'

// data
import {
  DASHBOARD_TOPPICKS,
  DASHBOARD_TOPPICKS_EMPTY,
  DASHBOARD_EVENTS,
  DASHBOARD_MERCHANTS,
  DASHBOARD_PROMOS,
  DASHBOARD_PROMOS_EMPTY,
} from '../../../../services/data/errorNames.json'
import { FAQ_PAGE, MAIN } from '../../../../services/data/profilePages.json'
import { DASHBOARD } from '../../../../services/data/marketingContentAppearance'
import getMarketingContentLabel from '../../../../services/data/getMarketingContentLabel'
import filterString from '../../../../services/data/filterString'
import viewTypeBaseUrl from '../../../../services/data/viewTypeBaseUrl'

// analytics
import {
  setGAPageView,
  setGAEvent,
} from '../../../../services/analytics/google-analytics'

// controllers
import {
  doGetDashboardSections,
  doGetDashboardHeroBanner,
  doGetDashboardExploreMerchants,
} from '../../../../controllers/Dashboard'
import {
  doGetAllMalls,
  doGetAllCMSMalls,
  doGetMallModalData,
} from '../../../../controllers/Malls'
import { doGetFeatureStatuses } from '../../../../controllers/Features'
import { doGetDashboardStore } from '../../../../controllers/Explore'
import { doOpenSureSeats } from '../../../../controllers/SSO'

const sectionDescription = doGetDashboardSections()

class MainView extends React.Component {
  constructor(props) {
    super(props)

    this.featuredSlider = React.createRef()
    this.promosSlider = React.createRef()
    this.eventsSlider = React.createRef()
    this.moviesSlider = React.createRef()
    this.merchantsSlider = React.createRef()
    this.pasyalArticlesSlider = React.createRef()

    this.state = {
      cardListModalOption: {},
      displayContactUs: false,
      displayTermsAndConditions: false,
      displayPrivacyNotice: false,
      relatedArticles: [],
      eventsLoaded: false,
      promosLoaded: false,
    }
  }

  componentWillMount() {
    const { waitRenderServer } = this.props

    waitRenderServer(true)

    this.displayModal()
  }

  componentDidMount() {
    const {
      location,
      setMalls,
      setFeatureStatus,
      accessToken,
      setHeroBanner,
    } = this.props

    // ST-1930 fetch hero banner
    doGetDashboardHeroBanner({ setHeroBanner })

    // gets status of features (cinema status)
    doGetFeatureStatuses({ accessToken, setFeatureStatus })

    doGetAllMalls({ setMalls })

    this.doGetDashboardAllCMSMalls()
    this.doGetDashboardFeatured()
    this.doGetDashboardWhatsOn()
    this.doGetDashboardBestDeals()
    this.doGetDashboardExplore()

    setGAPageView(location.pathname)
  }

  componentDidUpdate(prevProps, prevState) {
    const { match, location } = this.props
    const { viewType, viewId } = match.params
    const {
      viewType: prevViewType,
      viewId: prevViewId,
    } = prevProps.match.params

    if (viewType !== prevViewType || viewId !== prevViewId) {
      this.displayModal()
    }

    if (location.pathname !== prevProps.location.pathname) {
      setGAPageView(location.pathname)
    }
  }

  setRelatedArticles = relatedArticles => {
    this.setState({ relatedArticles })
  }

  doGetDashboardAllCMSMalls = () => {
    const { setCMSMalls } = this.props
    const { errors: errorsObj } = this.state
    doGetAllCMSMalls({
      setCMSMalls,
      errorsObj,
      onError: obj => {
        this.setState(obj)
      },
    })
  }

  doGetDashboardFeatured = () => {
    const {
      setFeatured,
      setError,
      errorList,
      removeError,
      doGetFeaturedMarketingContent,
    } = this.props

    const pageLoadStart = Date.now()

    if (errorList.length) removeError(DASHBOARD_TOPPICKS)

    doGetFeaturedMarketingContent({
      setFeatured,
      onSuccess: data => {
        if (!data.length) {
          setError({
            name: DASHBOARD_TOPPICKS_EMPTY,
          })
        }
        setGAEvent(
          'page',
          'loading_duration',
          'dashboard_top_picks',
          Date.now() - pageLoadStart,
        )
      },
      onError: error => {
        setError({
          name: DASHBOARD_TOPPICKS,
          error: error.message,
        })
      },
    })(10, DASHBOARD)
  }

  doGetDashboardWhatsOn = () => {
    const {
      setEvents,
      setError,
      errorList,
      removeError,
      doGetWhatsOn,
    } = this.props

    const pageLoadStart = Date.now()

    if (errorList.length) {
      removeError(DASHBOARD_EVENTS)
    }

    this.setState({ eventsLoaded: true })

    doGetWhatsOn({
      setWhatsOn: setEvents,
      onSuccess: () => {
        setGAEvent(
          'page',
          'loading_duration',
          'dashboard_whats_on',
          Date.now() - pageLoadStart,
        )
      },
      onError: error => {
        setError({
          name: DASHBOARD_EVENTS,
          error: error.message,
        })
      },
    })(9)
  }

  doGetDashboardBestDeals = () => {
    const {
      setPromos,
      setError,
      errorList,
      removeError,
      doGetBestDeals,
    } = this.props

    const pageLoadStart = Date.now()

    if (errorList.length) {
      removeError(DASHBOARD_PROMOS)
    }

    doGetBestDeals({
      setBestDeals: data => setPromos(data),
      onSuccess: data => {
        if (!data.length) {
          setError({
            name: DASHBOARD_PROMOS_EMPTY,
          })
        }
        setGAEvent(
          'page',
          'loading_duration',
          'dashboard_best_deals',
          Date.now() - pageLoadStart,
        )

        this.setState({ promosLoaded: true })
      },
      onError: error => {
        setError({
          name: DASHBOARD_PROMOS,
          error: error.message,
        })
      },
    })(9)
  }

  doGetDashboardExplore = () => {
    const { setMerchants, setError, errorList, removeError } = this.props
    const pageLoadStart = Date.now()
    doGetDashboardExploreMerchants({
      setMerchants,
      setError,
      errorList,
      removeError,
      onSuccess: () => {
        this.setState({
          exploreLoaded: true,
        })
        setGAEvent(
          'page',
          'loading_duration',
          'explore_now',
          Date.now() - pageLoadStart,
        )
      },
    })(9)
  }

  toggleTermsAndConditions = state => {
    const { push } = this.props
    this.setState({
      displayTermsAndConditions: state,
    })
    if (state === false) {
      push('/')
    }
  }

  togglePrivacyNotice = state => {
    const { push } = this.props
    this.setState({
      displayPrivacyNotice: state,
    })
    if (state === false) {
      push('/')
    }
  }

  featuredSliderNext = () => {
    this.featuredSlider.current.slickNext()
  }

  featuredSliderPrev = () => {
    this.featuredSlider.current.slickPrev()
  }

  promosSliderNext = () => {
    this.promosSlider.current.slickNext()
  }

  promosSliderPrev = () => {
    this.promosSlider.current.slickPrev()
  }

  eventsSliderNext = () => {
    this.eventsSlider.current.slickNext()
  }

  eventsSliderPrev = () => {
    this.eventsSlider.current.slickPrev()
  }

  merchantsSliderNext = () => {
    this.merchantsSlider.current.slickNext()
  }

  merchantsSliderPrev = () => {
    this.merchantsSlider.current.slickPrev()
  }

  handleClickCinemas = async e => {
    const { displayProfileModal, featureStatus } = this.props
    const cinemaFeature = featureStatus.filter(
      feature => feature.itemCode === 'CINEMAS',
    )[0]

    if (cinemaFeature.description || !(cinemaFeature.status === 2)) {
      e.preventDefault()
      // ST-1091 redirect to sureseats
      // this.setCinemaModalVisible(true)(e) // remove sureseats redirection in prod release
      await doOpenSureSeats()
      return
    }
    displayProfileModal(false)
  }

  handleClose = () => {
    const {
      push,
      setMarketingContentModalData,
      setMarketingContentModalStatus,
      setCurrentMallInModal,
      setOurMallModalStatus,
      setCardListModalStatus,
    } = this.props

    if (push) {
      push({ pathname: '/', data: { fromModal: true } })
      setMarketingContentModalData({})
      setMarketingContentModalStatus(null)
      setCurrentMallInModal(null)
      setOurMallModalStatus(null)
      setCardListModalStatus(null)
    }
  }

  displayModal = async () => {
    const {
      match,
      // promos,
      events,
      cmsMalls,
      merchants,
      setMarketingContentModalData,
      setMarketingContentModalStatus,
      setStoreModalData,
      setCurrentMallInModal,
      setOurMallModalStatus,
      setCardListModalData,
      setCardListModalStatus,
      displayProfileModal,
      setProfileModalPage,
      setDisplayAppModal,
      renderServer,
      doGetRelatedArticles,
      doGetMarketingContent,
      doGetWhatsOn,
      doGetBestDeals,
      doGetFeaturedMarketingContent,
    } = this.props
    const { viewType, viewId } = match.params
    if (viewType === 'download-app') {
      setDisplayAppModal(true)
    } else if (viewType === 'termsandconditions') {
      this.toggleTermsAndConditions(true)
    } else if (viewType === 'privacy-notice') {
      this.togglePrivacyNotice(true)
    } else if (viewType === 'faq') {
      displayProfileModal(true)
      setProfileModalPage(FAQ_PAGE)
    } else if (viewType === 'more') {
      displayProfileModal(true)
      setProfileModalPage(MAIN)
    } else if (
      (viewType === 'event' ||
        viewType === 'promo' ||
        viewType === 'ads' ||
        viewType === 'announcements' ||
        viewType === 'others') &&
      viewId
    ) {
      setMarketingContentModalStatus(1)
      const contentId = viewId.split('-').pop()

      setCardListModalStatus(null)
      const filteredData = events.filter(({ id }) => `${id}` === `${contentId}`)
      let contentModalData = filteredData[0] || null

      doGetRelatedArticles({ setRelatedArticles: this.setRelatedArticles })(
        contentId,
      )
      if (!contentModalData) {
        await doGetMarketingContent({
          setMarketingContent: setMarketingContentModalData,
          onSuccess: () => setMarketingContentModalStatus(0),
          onError: () => setMarketingContentModalStatus(4),
        })(contentId)
      } else {
        setMarketingContentModalData({
          ...contentModalData,
          body: contentModalData.body.replace(/<a href="(.+?)"/g, (_, url) => {
            const isAbsolute =
              url.startsWith('http://') || url.startsWith('https://')
            const theUrl = isAbsolute ? url : `http://${url}`
            return `<a href="${theUrl}" target="_blank"`
          }),
        })
        setMarketingContentModalStatus(0)
      }
    } else if (viewType === 'merchant' && viewId) {
      const filteredData = merchants.filter(({ id }) => `${id}` === `${viewId}`)
      const storeModalData = filteredData[0] || {}

      doGetDashboardStore({ setStoreModalData, storeId: storeModalData.id })
    } else if (viewType === 'malls') {
      const filteredData = cmsMalls.filter(
        ({ id, slugName }) => `${slugName || id}` === `${viewId}`,
      )
      let mallModalData = filteredData[0] || null

      if (!mallModalData) {
        try {
          setOurMallModalStatus(1)

          mallModalData = await doGetMallModalData({ viewId })
        } catch (e) {
          setOurMallModalStatus(4)
        }
      }
      if (mallModalData) {
        setCurrentMallInModal(mallModalData)
        setOurMallModalStatus(0)
      }
    } else if (viewType === 'events') {
      doGetWhatsOn({
        setWhatsOn: setCardListModalData,
        onSuccess: () => setCardListModalStatus(0),
        onError: () => {
          setCardListModalData([])
          setCardListModalStatus(4)
        },
      })()

      this.setState({
        cardListModalOption: sectionDescription.event,
      })
    } else if (viewType === 'promos') {
      doGetBestDeals({
        setBestDeals: setCardListModalData,
        onSuccess: () => setCardListModalStatus(0),
        onError: () => {
          setCardListModalData([])
          setCardListModalStatus(4)
        },
      })()

      this.setState({
        cardListModalOption: sectionDescription.promo,
      })
    } else if (viewType === 'top-picks') {
      doGetFeaturedMarketingContent({
        setFeatured: setCardListModalData,
        onSuccess: () => setCardListModalStatus(0),
        onError: () => {
          setCardListModalData([])
          setCardListModalStatus(4)
        },
      })('', DASHBOARD)

      this.setState({
        cardListModalOption: sectionDescription.featured,
      })
    } else {
      setMarketingContentModalData({})
      setMarketingContentModalStatus(null)
      setCurrentMallInModal(null)
      setOurMallModalStatus(null)
      setCardListModalStatus(null)
      displayProfileModal(false)
      setDisplayAppModal(false)

      setGAEvent('page', 'page_visit', 'home')
    }
    renderServer()
  }

  render() {
    const {
      match,
      push,
      heroBanner,
      featured,
      promos,
      events,
      movies,
      merchants,
      malls,
      cmsMalls,
      baseUrl,
      featureStatus,
      showMarketingContentModal,
      marketingContentModalData,
      marketingContentModalStatus,
      cardListModalData,
      showCardListModal,
      cardListModalStatus,
      showMerchantsListModal,
      merchantsListModalData,
      setMerchantsListModalData,
      showStoreModal,
      storeModalData,
      setStoreModalData,
      currentMallInModal,
      showOurMallModal,
      ourMallModalStatus,
      errorList,
      selectedMallSlug,
      pasyalArticles,
      doContactUsSubmit,
      primaryInfo,
      ...theProps
    } = this.props

    const {
      cardListModalOption,
      displayContactUs,
      displayTermsAndConditions,
      displayPrivacyNotice,
      relatedArticles,
      eventsLoaded,
      promosLoaded,
    } = this.state

    const getBestDealsDataObj = () => {
      const switchCarousel = events.length === 0
      let obj = {
        contentDirection: 'rtl',
        reverse: true,
        dataSource: [...promos].reverse(),
      }
      if (eventsLoaded && promosLoaded) {
        if (switchCarousel) {
          obj = {
            contentDirection: 'ltr',
            reverse: false,
            dataSource: [...promos],
          }
        }
      }
      return {
        key: 'promos-carousel',
        initialSlide: switchCarousel ? promos.length - 1 : 0,
        ...obj,
      }
    }

    const getExploreDataObj = () => {
      const reducer = (prev, curr) => (curr ? prev + 1 : prev)
      const hasEvents = events.length > 0
      const hasPromos = promos.length > 0
      const noOfCollapsed = [hasEvents, hasPromos].reduce(reducer, 0)
      const switchCarousel = noOfCollapsed % 2 !== 0
      let obj = {
        contentDirection: 'ltr',
        reverse: false,
        dataSource: [...merchants],
      }
      if (eventsLoaded && promosLoaded) {
        // ST-1617 hide pasyal section
        if (switchCarousel) {
          obj = {
            contentDirection: 'rtl',
            reverse: true,
            dataSource: [...merchants].reverse(),
          }
        }
      }
      return {
        key: 'explore-carousel',
        initialSlide: switchCarousel ? merchants.length - 1 : 0,
        ...obj,
      }
    }

    const heroBannerData = {
      desktopBanner: {
        url: heroBanner && heroBanner.desktopBanner.url,
      },
    }
    const bestDealsObj = getBestDealsDataObj()
    const exploreObj = getExploreDataObj()

    return (
      <>
        <DashboardLayout
          variant="main"
          heroBannerData={heroBannerData}
          heroBannerLeft={heroBanner && !heroBanner.layout}
          {...(!!heroBanner?.desktopCaption?.showCaption && {
            heroBannerTitle: (
              <BannerCaption
                src={heroBanner && heroBanner.desktopCaption.url}
              />
            ),
          })}
          featuredSection={
            !errorList.find(
              error => error.name === DASHBOARD_TOPPICKS_EMPTY,
            ) && (
              <>
                <CardSlider
                  dataSource={featured}
                  loadingComponent={() => (
                    <FeaturedCard
                      key={JSON.stringify(errorList)}
                      loading
                      error={errorList.find(
                        error =>
                          error.name === DASHBOARD_TOPPICKS ||
                          error.name === DASHBOARD_TOPPICKS_EMPTY,
                      )}
                      onRetry={this.doGetDashboardFeatured}
                    />
                  )}
                  ref={this.featuredSlider}
                  featured
                  renderItem={(item, index) => {
                    const newIndex = index + 1
                    const newId = featured.length === newIndex ? 0 : newIndex

                    return (
                      <FeaturedCard
                        key={item.itemId}
                        id={newId}
                        featuredImgUrl={item.logoUrl || ''}
                        bannerImgUrl={item.imageUrl || ''}
                        schedule={item.subtitle || ''}
                        title={item.title}
                        item={item}
                        body={filterString(item.description)}
                        label={getMarketingContentLabel(item).name}
                        link={`${viewTypeBaseUrl(item.type)}/${item.slugName}`}
                        // link={`${viewTypeBaseUrl(item.type)}/${
                        //   item.type === 0 || item.type === 1
                        //     ? item.slugName
                        //     : item.itemId
                        // }`}
                        //
                        onClick={() =>
                          setGAEvent(
                            'item_clicks',
                            'view_dashboard_top_picks_item',
                            item.title,
                          )
                        }
                      />
                    )
                  }}
                  onViewAllClick={() => {
                    setGAEvent(
                      'home_section',
                      'section_view_all_click',
                      'top_picks_view_all',
                    )
                    push(`${baseUrl}/top-picks`)
                  }}
                />

                <ButtonNavWrapper left>
                  <ButtonNav onClick={this.featuredSliderPrev}>
                    <Icon name="slide-left" />
                  </ButtonNav>
                </ButtonNavWrapper>

                <ButtonNavWrapper>
                  <ButtonNav onClick={this.featuredSliderNext} right>
                    <Icon name="slide-right" />
                  </ButtonNav>
                </ButtonNavWrapper>
              </>
            )
          }
          heroLink="/explore"
          altHeaderAd
          altFooterAd
          {...theProps}
        >
          {events && events.length > 0 && (
            // Whats On Section
            <Section
              sectionTitle={sectionDescription.event.title}
              sectionText={sectionDescription.event.description}
              sectionContentType="small"
              sliderNext={this.eventsSliderNext}
              sliderPrev={this.eventsSliderPrev}
              to="/promos-and-events/whats-on"
              onClick={() =>
                setGAEvent(
                  'home_section',
                  'section_view_all_click',
                  'whats_on_view_all',
                )
              }
              lightOnSmall
            >
              <CardSlider
                dataSource={events}
                loadingComponent={() => (
                  <EventsCard
                    key={JSON.stringify(errorList)}
                    loading
                    error={errorList.find(
                      error => error.name === DASHBOARD_EVENTS,
                    )}
                    onRetry={this.doGetDashboardWhatsOn}
                  />
                )}
                ref={this.eventsSlider}
                renderItem={(item, index) => (
                  <EventsCard
                    key={item.itemId}
                    id={index}
                    logoImageUrl={item.logoUrl}
                    subtitle={item.subtitle}
                    title={item.title}
                    link={`${viewTypeBaseUrl(item.type)}/${item.slugName}`}
                    onClick={() =>
                      setGAEvent(
                        'item_clicks',
                        'view_dashboard_whats_on_item',
                        item.title,
                      )
                    }
                    malls={item.malls}
                  />
                )}
              />
            </Section>
          )}

          {!errorList.find(error => error.name === DASHBOARD_PROMOS_EMPTY) &&
            eventsLoaded &&
            promosLoaded && (
              // Best Deals Section
              <>
                <ResponsiveAdsContainer
                  desktop={<DesktopLeaderboard id="div-ad-innity-91042/6" />}
                  mobile={<MobileRectangle id="div-ad-innity-91046/6" />}
                />
                <Section
                  contentDirection={bestDealsObj.contentDirection}
                  reverse={bestDealsObj.reverse}
                  sectionTitle={sectionDescription.promo.title}
                  sectionText={sectionDescription.promo.description}
                  sliderNext={this.promosSliderNext}
                  sliderPrev={this.promosSliderPrev}
                  sectionContentType="small"
                  to="/promos-and-events/best-deals"
                  onClick={() =>
                    setGAEvent(
                      'home_section',
                      'section_view_all_click',
                      'best_deals_view_all',
                    )
                  }
                >
                  <CardSlider
                    key={bestDealsObj.key}
                    loading={!eventsLoaded || !promosLoaded} // ST-1617 hide pasyal section
                    loadingComponent={() => (
                      <PromoCard
                        key={JSON.stringify(errorList)}
                        loading
                        error={errorList.find(
                          error => error.name === DASHBOARD_PROMOS,
                        )}
                        onRetry={this.doGetDashboardBestDeals}
                      />
                    )}
                    ref={this.promosSlider}
                    dataSource={bestDealsObj.dataSource}
                    initialSlide={bestDealsObj.initialSlide}
                    renderItem={(item, index) => (
                      <PromoCard
                        key={item.itemId}
                        id={promos.length - (index + 1)}
                        logoImageUrl={item.logoUrl}
                        subtitle={item.subtitle}
                        title={item.title}
                        link={`${viewTypeBaseUrl(item.type)}/${item.slugName}`}
                        onClick={() =>
                          setGAEvent(
                            'item_clicks',
                            'view_dashboard_best_deals_item',
                            item.title,
                          )
                        }
                        malls={item.malls}
                      />
                    )}
                  />
                </Section>
              </>
            )}

          {/* Explore Section */}
          <Section
            contentDirection={exploreObj.contentDirection}
            reverse={exploreObj.reverse}
            sectionTitle="Explore"
            sectionText="Easily navigate your way around Ayala Malls. Spend less time searching, and more time discovering amazing experiences."
            sectionContentType="small"
            sliderNext={this.merchantsSliderNext}
            sliderPrev={this.merchantsSliderPrev}
            to={selectedMallSlug ? `/explore/${selectedMallSlug}` : '/explore'}
            onClick={() =>
              setGAEvent(
                'home_section',
                'section_view_all_click',
                'explore_now_view_all',
              )
            }
          >
            <SliderLoader
              key={exploreObj.key}
              ref={this.merchantsSlider}
              dataLoaded={eventsLoaded && promosLoaded} // ST-1617 hide pasyal section
              hasError={errorList.find(
                error => error.name === DASHBOARD_MERCHANTS,
              )}
              loadingComponent={() => (
                <ShopDineCard
                  key={JSON.stringify(errorList)}
                  loading
                  error={errorList.find(
                    error => error.name === DASHBOARD_MERCHANTS,
                  )}
                  onRetry={this.doGetDashboardExplore}
                />
              )}
              sliderData={{
                dataSource: exploreObj.dataSource,
                initialSlide: exploreObj.initialSlide,
                renderItem: (item, index) => (
                  <ShopDineCard
                    key={item.itemId}
                    id={index}
                    iconUrl={item.logoUrl}
                    cardImageUrl={item.imageUrl || ''}
                    title={item.title}
                    link={`/explore/malls/store/${item.itemId}`}
                    onClick={() =>
                      setGAEvent(
                        'item_clicks',
                        'view_explore_now_item',
                        item.title,
                      )
                    }
                  />
                ),
              }}
            />
          </Section>

          <MerchantsListModal
            data={merchantsListModalData}
            show={showMerchantsListModal}
            setMerchantsListModalData={setMerchantsListModalData}
            showStoreModal={showStoreModal}
            setStoreModalData={setStoreModalData}
          />
          <StoreModal
            malls={malls}
            show={showStoreModal}
            data={storeModalData}
            setStoreModalData={setStoreModalData}
            merchantsListModalData={merchantsListModalData}
            onClose={() => setStoreModalData(null)}
          />
          <MarketingContentModal
            malls={malls}
            show={showMarketingContentModal}
            data={{ ...marketingContentModalData, relatedArticles }}
            shareUrl={`${process.env.REACT_APP_BASE_URL}${encodeURI(
              match.url,
            )}`}
            onClose={this.handleClose}
            setMerchantsListModalData={setMerchantsListModalData}
            showMerchantsListModal={showMerchantsListModal}
            loading={marketingContentModalStatus}
          />
          <OurMallsModal
            malls={cmsMalls}
            show={showOurMallModal}
            baseUrl={`${baseUrl}/malls`}
            currentMall={currentMallInModal}
            onClose={this.handleClose}
            loading={ourMallModalStatus}
          />
          <ContactUsModal
            show={displayContactUs}
            onSubmit={doContactUsSubmit()}
            shouldCloseOnOverlayClick={false}
            onClose={() => this.toggleContactUs(false)}
          />
          <TncModal
            show={displayTermsAndConditions}
            onClose={() => this.toggleTermsAndConditions(false)}
          />
          <PrivacyNoticeModal
            show={displayPrivacyNotice}
            onClose={() => this.togglePrivacyNotice(false)}
          />
          <CardListModal
            show={showCardListModal}
            onClose={this.handleClose}
            loading={cardListModalStatus}
            title={cardListModalOption.title}
            description={cardListModalOption.description}
            source={cardListModalData}
            render={item => {
              const { title, type, subtitle, imageUrl, logoUrl } = item
              const linkBaseUrl = viewTypeBaseUrl(type)
              return (
                <ArticleCard
                  key={`${type}-${item.itemId}`}
                  imageUrl={imageUrl}
                  logoUrl={logoUrl}
                  title={title}
                  schedule={subtitle}
                  link={`${linkBaseUrl}/${item.slugName}`}
                />
              )
            }}
          />
          {showMarketingContentModal && marketingContentModalData && (
            <Helmet defaultTitle={marketingContentModalData.title}>
              <meta
                property="og:title"
                content={marketingContentModalData.title}
              />
              <meta
                property="og:description"
                content={filterString(marketingContentModalData.body)}
              />
              <meta
                property="og:image"
                content={
                  marketingContentModalData.featuredImage
                    ? marketingContentModalData.featuredImage.url
                    : ''
                }
              />
              <meta property="og:type" content="website" />
            </Helmet>
          )}
          {showOurMallModal && currentMallInModal && (
            <Helmet defaultTitle={currentMallInModal.name}>
              <meta property="og:title" content={currentMallInModal.name} />
              <meta
                property="og:description"
                content={filterString(currentMallInModal.description)}
              />
              <meta
                property="og:image"
                content={
                  currentMallInModal.photos && currentMallInModal.photos.length
                    ? currentMallInModal.photos[0].url
                    : ''
                }
              />
              <meta property="og:type" content="website" />
            </Helmet>
          )}
        </DashboardLayout>
      </>
    )
  }
}

MainView.defaultProps = {
  // TODO: specify default props
}

MainView.propTypes = {
  // TODO: specify prop types
}

export default withRouter(MainView)
